import React from 'react';
import * as S from './References.styles';

export const References: React.FC = () => {
  return (
    <S.ReferencesWrapper>
      <S.Text>
        Made by{' '}
        <a href="https://cybexai.com" target="_blank" rel="noreferrer">
          CYBEX.Ai{' '}
        </a>
        in {new Date().getFullYear()} &copy;
      </S.Text>
    </S.ReferencesWrapper>
  );
};
